import { ComponentType, lazy } from 'react'

const Landing = lazy(() => import('./pages/index'))
const Overview = lazy(() => import('./pages/overview'))
const MqttShareViewer = lazy(() => import('./pages/mqtt-share-viewer'))
const DeviceStats = lazy(() => import('./pages/devices/[id]/index'))
const DeviceEdit = lazy(() => import('./pages/devices/[id]/edit'))
const Groups = lazy(() => import('./pages/groups/index'))
const GroupDetail = lazy(() => import('./pages/groups/[groupId]'))
const Profile = lazy(() => import('./pages/profile/index'))
const ChangePassword = lazy(() => import('./pages/profile/change-password'))
const AdminBrokerStatistics = lazy(() => import('./pages/admin/broker-statistics/index'))
const AdminDevices = lazy(() => import('./pages/admin/devices/index'))
const AdminOsmExport = lazy(() => import('./pages/admin/export/osm'))
const AdminGroups = lazy(() => import('./pages/admin/groups/index'))
const AdminGroup = lazy(() => import('./pages/admin/groups/[id]'))
const AdminJob = lazy(() => import('./pages/admin/jobs/[name]'))
const AdminReconciliation = lazy(() => import('./pages/admin/reconciliation/index'))
const AdminReleaseNotes = lazy(() => import('./pages/admin/release-notes'))
const AdminSettings = lazy(() => import('./pages/admin/settings/index'))
const AdminUsers = lazy(() => import('./pages/admin/users/index'))
const AdminUser = lazy(() => import('./pages/admin/users/[id]'))
const AuthCheckEmail = lazy(() => import('./pages/auth/check-email'))
const AuthError = lazy(() => import('./pages/auth/error'))
const AuthRecover = lazy(() => import('./pages/auth/recover'))
const AuthRegister = lazy(() => import('./pages/auth/register'))
const AuthSettings = lazy(() => import('./pages/auth/settings'))
const AuthSignin = lazy(() => import('./pages/auth/signin'))
const ExperimentGoogleMaps = lazy(() => import('./pages/experiments/google-maps'))
const ExperimentOpenStreetMap = lazy(() => import('./pages/experiments/open-street-map'))
const LegalPrivacy = lazy(() => import('./pages/legal/privacy'))
const LegalTerms = lazy(() => import('./pages/legal/terms'))

// Every page by its address; `[name]` is a segment the page reads from
// useRouter().query. An address matching none shows pages/404. Each page is
// its own chunk of the build, loaded when it is first shown.
export const routes: [string, ComponentType][] = [
  ['/', Landing],
  ['/overview', Overview],
  ['/mqtt-share-viewer', MqttShareViewer],
  ['/devices/[id]', DeviceStats],
  ['/devices/[id]/edit', DeviceEdit],
  ['/groups', Groups],
  ['/groups/[groupId]', GroupDetail],
  ['/profile', Profile],
  ['/profile/change-password', ChangePassword],
  ['/admin/broker-statistics', AdminBrokerStatistics],
  ['/admin/devices', AdminDevices],
  ['/admin/export/osm', AdminOsmExport],
  ['/admin/groups', AdminGroups],
  ['/admin/groups/[id]', AdminGroup],
  ['/admin/jobs/[name]', AdminJob],
  ['/admin/reconciliation', AdminReconciliation],
  ['/admin/release-notes', AdminReleaseNotes],
  ['/admin/settings', AdminSettings],
  ['/admin/users', AdminUsers],
  ['/admin/users/[id]', AdminUser],
  ['/auth/check-email', AuthCheckEmail],
  ['/auth/error', AuthError],
  ['/auth/recover', AuthRecover],
  ['/auth/register', AuthRegister],
  ['/auth/settings', AuthSettings],
  ['/auth/signin', AuthSignin],
  ['/experiments/google-maps', ExperimentGoogleMaps],
  ['/experiments/open-street-map', ExperimentOpenStreetMap],
  ['/legal/privacy', LegalPrivacy],
  ['/legal/terms', LegalTerms],
]
